// AI Generated Component
import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { AssignProfileService } from '@client/app/modules/page-performance/services/assign-profile/assign-profile.service';
import { AssignedProfilesRepoService } from '@client/app/services/api/page-performance/assigned-profile-repo/assigned-profiles-repo.service';
import { PAGE_DETAILS_SECTION_CONSTANT } from '@client/app/components/pagedetails/details/sections/page-details-section.constant';

@Component({
    selector: 'page-details-dashboard-charts-page-performance',
    standalone: false,
    template: `
        <div class="row align-items-center" *ngIf="pageHasProfile">
            <div class="offset-4 col-18 page-dashboard-doughnut-container">
                <page-performance-score-doughnut-chart *ngIf="!loading" [score]="score">
                </page-performance-score-doughnut-chart>
            </div>
            <div class="col-26 pl-0">
                <notification-change
                    [title]="'Performance score' | translate"
                    [digit]="score"
                    (click)="onClickHandler.emit({ params: { target: pageDetailsSectionPagePerformance } })">
                    <div class="mt-3" translate>Last load time</div>
                </notification-change>
                <div class="page-performance-last-load-time-indicators d-flex flex-column flex-wrap justify-content-between">
                    <div class="text-nowrap ml-4 mb-2 d-flex">
                        <div class="page-performance-last-load-time-indicator">
                            <span class="last-load-time-color-indicator ruler-fcp"
                                  ngbTooltip="{{ 'First Contentful Paint' | translate }}"
                                  (click)="onClickHandler.emit({ params: { target: pageDetailsSectionPagePerformance } })">
                            </span>
                            <span class="text-bold mr-1"
                                  (click)="onClickHandler.emit({ params: { target: pageDetailsSectionPagePerformance } })">
                                {{firstContentfulPaint | monNumber}} ms
                            </span>
                        </div>
                        <div class="page-performance-last-load-time-indicator">
                            <span class="last-load-time-color-indicator ruler-fmp"
                                  ngbTooltip="{{ 'First Meaningful Paint' | translate }}"
                                  (click)="onClickHandler.emit({ params: { target: pageDetailsSectionPagePerformance } })">
                            </span>
                            <span class="text-bold mr-1"
                                  (click)="onClickHandler.emit({ params: { target: pageDetailsSectionPagePerformance } })">
                                {{firstMeaningfulPaint | monNumber}} ms
                            </span>
                        </div>
                        <div class="page-performance-last-load-time-indicator">
                            <span class="last-load-time-color-indicator ruler-tti"
                                  ngbTooltip="{{ 'Time To Interactive' | translate }}"
                                  (click)="onClickHandler.emit({ params: { target: pageDetailsSectionPagePerformance } })">
                            </span>
                            <span class="text-bold mr-1"
                                  (click)="onClickHandler.emit({ params: { target: pageDetailsSectionPagePerformance } })">
                                {{timeToInteractive | monNumber}} ms
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="no-data-card text-center" *ngIf="!pageHasProfile && !rescanProfileStarted && !loading">
            <h3 class="font-weight-300 text-grey py-8" translate>This page has not been assigned to the Performance Module</h3>
            <button class="btn btn-border-radius btn-secondary font-size-1-3 font-weight-400"
                    type="button"
                    (click)="assignProfile()"
                    *ngIf="['customer_admin'] | role"
                    translate>
                Assign to the Performance Module
            </button>
        </div>
        <div *ngIf="rescanProfileStarted" class="row text-center">
            <div class="col-48 text-center">
                <h3 class="text-center font-weight-300 text-grey py-6" translate>No scan has yet been performed. Please check back later.</h3>
            </div>
        </div>
    `,
})
export class PageDetailsDashboardChartsPagePerformanceComponent implements OnInit {
    @Input() page: any;
    @Output() onClickHandler = new EventEmitter<any>();

    firstContentfulPaint = 0;
    firstMeaningfulPaint = 0;
    timeToInteractive = 0;
    loading = true;
    rescanProfileStarted = false;
    pageHasProfile = false;
    pageDetailsSectionPagePerformance = PAGE_DETAILS_SECTION_CONSTANT.PERFORMANCE;
    score = 0;

    constructor (
        private assignProfileService: AssignProfileService,
        private assignedProfilesRepoService: AssignedProfilesRepoService,
    ) {}

    ngOnInit (): void {
        this.activate();
    }

    activate (): void {
        this.firstContentfulPaint = 0;
        this.firstMeaningfulPaint = 0;
        this.timeToInteractive = 0;
        this.loading = true;
        this.rescanProfileStarted = this.assignProfileService.isRescanProfileStarted();
        this.pageHasProfile = false;
        this.pageDetailsSectionPagePerformance = PAGE_DETAILS_SECTION_CONSTANT.PERFORMANCE;

        this.assignedProfilesRepoService.getAll({ page_id: this.page.id })
            .then((assignedProfiles: any[]) => {
                const profile = assignedProfiles.find((item: any) => {
                    return item.page.id === this.page.id;
                });

                if (profile) {
                    this.pageHasProfile = true;
                    this.score = profile.scores.performance * 100;
                    this.firstContentfulPaint = profile.scores.first_contentful_paint;
                    this.firstMeaningfulPaint = profile.scores.first_meaningful_paint;
                    this.timeToInteractive = profile.scores.time_to_interactive;
                }
            })
            .catch(() => {
                // Handle error silently like in original
            })
            .finally(() => {
                this.loading = false;
            });
    }

    assignProfile (): void {
        this.assignProfileService.assignProfile(this.page).then(() => {
            this.rescanProfileStarted = this.assignProfileService.isRescanProfileStarted();
        }).catch(() => {
            // Handle error silently like in original
        });
    }
}
